import { openNav, closeNav, initMap, waitForEl } from "./main"
import "./scroll"

window.waitForEl=waitForEl;
window.openNav=openNav;
window.closeNav=closeNav;
window.initMap=initMap;